// OGeet Café & Lounge — Hazelwood menu

export const OGEET_MENU_PDF =
  'https://customer-assets.emergentagent.com/job_574cc8bd-edef-41b9-82d3-6a702d274bcf/artifacts/3nnttbax_O%27GEET%20HAZELWOOD%20.pdf';

const i = (name, price, desc) => ({ name, price, desc });

export const OGEET_MENU = [
  {
    id: 'veg-appetisers',
    title: 'Veg Appetisers',
    eyebrow: 'To Begin',
    accent: '#FF1493',
    items: [
      i('Samoosa Moradabadi Dal', 'R85', 'Cocktail Punjabi samosa laced on a thick creamy yellow dhall, nuts & herbs.'),
      i('Podi Mushrooms', 'R85 / 5pc', 'Whole double-combo mushrooms stuffed with masala cheese, crumbed and deep-fried, served with pineapple raita.'),
      i('Onion Beetroot Tangle (v)', 'R85', "Sliced onion and beetroot in chef's spice, deep-fried on a creamy beetroot sauce."),
      i('Soji Tikki', 'R85 / 5pc', 'Crispy potato, spinach and pea balls stuffed with paneer; tamarind and mint sauce.'),
      i('Spinach Avocado Puri', 'R85', 'Home-made spinach puri stuffed with avocado chilli.'),
      i('Tandoori Phadi Soya Kebab', 'R85', "Soya recreated — a Geet specialty."),
      i('Paneer Jafran', 'R85', 'Paneer pre-marinated in saffron and home-made yoghurt, grilled.'),
      i("Kalonji Spinach Paneer O'Geet Bites", 'R85', 'Your favourite palak-paneer appetizer with a unique twist.'),
      i('Cheese Kurjure', 'R85', 'Home-made cheese wrapped in spicy rumali roti, char-grilled.'),
      i('Spicy Peri Peri Cheese Cone Balls', 'R85', 'Cheese balls gently tucked in a cheese nest.'),
    ],
  },
  {
    id: 'nonveg-starters',
    title: 'Non-Veg Starters',
    eyebrow: 'From the Grill',
    accent: '#FFB300',
    items: [
      i('Flame-Grilled Lamb Chops', 'R280', 'Signature churn glaze, avocado chokha, burnt-garlic rice.'),
      i('Zazzi Prawn & Scallops', 'R275', "Prawn spiced in chef's specialty, wrapped in papadum and deep-fried."),
      i('Tandoori Anarkali Kingklip Kebab', 'Market', 'Kingklip in a lentil masala flour crust, served with potato masala wedges.'),
      i('Anarkali Kebab', 'R90', 'Chicken in yogurt paste, lightly spiced and char-grilled with pomegranate.'),
      i('Cochin Coast Crusted Prawn', 'Market', 'Prawns in golden lentil & coconut crust on a velvet spiced creamy base.'),
      i('Sooka Murgh Chicken', 'R90', 'Tandoori chicken tossed with herbs and spices, creamy tamarind chutney.'),
      i('Bang Bang Chicken Kebab', 'R90', "Cumin-flavoured drumsticks with master chef's spice, char-grilled."),
      i('Potli Prawns', 'Market', 'Crumbed prawn sewn in a homemade cumin parcel, deep-fried.'),
      i('Duck / Chicken / Prawn Momo Dumplings', 'Market', "Pan-tossed or tandoori — Indian flavours, O'Geet chilli crisp."),
    ],
  },
  {
    id: 'geet-calls',
    title: "'Geet Calls",
    eyebrow: 'Signatures',
    accent: '#6A1B9A',
    items: [
      i('Pizza Butter Chicken Balloons', 'R125', "O'Geet balloon flavour — cheesy surprise."),
      i('Stuffed Tangari Kebab', 'R110', 'Stuffed minced chicken kebab on the drumstick.'),
      i('Butter Chicken Bombs', 'R95', 'Boneless chicken shredded and rolled in spicy dough.'),
      i('Zafran Kebab', 'R95', 'Yogurt-pasted chicken, spiced and char-grilled with pomegranate.'),
      i('Beetroot Crowned Chicken', 'R95', 'Tandoori chicken, creamy tamarind chutney, grilled.'),
      i('Tawa Garlic Chicken Wings', 'R85', 'Deep-onion flavoured wings with shallots & spring onions.'),
      i('Creamy Malai Lollypop', 'R85', "Wings flavoured with master chef's spice and deep-fried."),
      i('Kasturi Murgh Malai', 'R85', "Chicken with heavy spices, tangy marinade, flame-grilled — OGeet specialty."),
    ],
  },
  {
    id: 'chaats',
    title: 'Chaats',
    eyebrow: 'Street Snacks',
    accent: '#00BFA5',
    items: [
      i('Dahi Puri', 'R80', 'Semolina puffed shells with chickpeas, potato, yogurt and tamarind.'),
      i('Gol Gappe', 'R80', 'Semolina puffs with mouthwatering masala pani.'),
      i('Bombay Bhel', 'R80', 'Tangy puffed rice tossed with fresh ingredients.'),
      i('Palak Pata Chaat', 'R80', 'Crispy baby spinach with batter yogurt and tamarind.'),
      i('Punjabi Samoosa Chaat', 'R85', 'Specialty samosa layered with yogurt and tamarind.'),
      i('Chicken Tikka Gol Gappe', 'R85', 'Chicken cubes with tangy chaat masala.'),
      i('Prawn Puri Chaat', 'R155', 'Cocktail prawns with chaat masala.'),
    ],
  },
  {
    id: 'samosas',
    title: 'Hand-Crafted Samosas',
    eyebrow: 'A Box of Joy',
    accent: '#C2185B',
    items: [
      i('Cheese Corn Jalapeño', 'R75'),
      i('Potato & Green Lentil', 'R75'),
      i('Cocktail Punjabi', 'R85'),
      i('Paneer Bhurji', 'R75'),
      i('Mix Vegetable', 'R75'),
      i('Chilli Garlic Noodles', 'R75'),
      i('Chicken Jalapeño', 'R85'),
      i('Lamb Bhurji', 'R95'),
      i('Chicken Tikka', 'R85'),
      i('Prawn Bhurji', 'R95'),
    ],
  },
  {
    id: 'soups',
    title: 'Soups',
    eyebrow: 'Warm the Soul',
    accent: '#FF6F00',
    items: [
      i('Tom Young Soup', null, 'Pan-Asian flavours with a hint of sweet-sour — veg or mixed seafood.'),
      i('Broccoli Almond Pepper Soup', null, 'Garden-fresh broccoli with apricot cream.'),
      i('Tomato Soup', null, 'Green and red tomatoes blanched, basil-flavoured.'),
      i('Lamb Shank Soup', null, 'Awadi-style lamb reduction with shredded lamb.'),
      i('Chicken Momo Soup', null, 'Sweet-and-sour broth with homemade chicken momos.'),
      i('Vegetable Momo Soup', null, 'Sweet-and-sour broth with vegetable momos.'),
    ],
  },
  {
    id: 'indo-china',
    title: 'Indo-China to Chandni Chowk',
    eyebrow: 'Hakka & Beyond',
    accent: '#7B2C2C',
    items: [
      i('Paneer Chilli', 'R165', 'Battered paneer fried with chillies, ginger, garlic and spring onion.'),
      i('Veg Chilli Garlic Momos', 'R145', 'Hand-made fried dumplings, wok-tossed in Hakka chilli sauce.'),
      i('Veg Tandoori Dumplings', 'R145', 'Crispy smoky dumplings filled with spiced veggies, grilled in tandoori masala.'),
      i('Veg Chilli Garlic Noodles', 'R85', 'Hand-made noodles, wok-tossed in Hakka chilli sauce.'),
      i('Tandoori Duck / Chicken / Prawn Momos', 'Market', 'Crispy smoky momos with spiced chicken — grilled or steamed.'),
      i('Chicken Dumpling Soup', 'R180', "A chef's recreation — all-in-one flavour."),
      i('Cherry Blossom Dumplings', 'R180', "Gastronomic creation of 'Geet."),
      i('Foot Ball', 'R180', 'Stuffed chicken tikka dumplings recreated.'),
      i('Prawn Nutty Stir-Fried Noodle', 'R180', 'Noodles tossed with a spicy nutty twist.'),
      i('Chilli Chicken', 'R155', 'Battered chicken, wok-fried with chillies, ginger, garlic, spring onion.'),
      i('Chicken 65 Stir-Fried Noodle', 'R125'),
    ],
  },
  {
    id: 'indo-italiano',
    title: 'Indo Italiano',
    eyebrow: 'East Meets Mediterranean',
    accent: '#3F6249',
    items: [
      i('Butter Chicken Spaghetti / Penne', 'R210', 'Pasta in rich butter-chicken sauce.'),
      i('Rogan Josh Lamb Spaghetti / Penne', 'R250', 'Pasta in rich lamb rogan josh sauce.'),
      i('Coconut Lime Prawn Pasta', 'R340', 'Coconut & lime prawn pasta.'),
      i('Shahi Paneer Spaghetti / Penne', 'R225', 'Indian fusion — spaghetti with shahi paneer.'),
      i('Creamy Burnt Garlic Penne', 'R190', 'Burnt-garlic creamy sauce pasta.'),
      i('Cocktail Garlic Khulcha (2pc) with any Pasta', 'R85'),
    ],
  },
  {
    id: 'curries-vegan',
    title: 'Pahadi Curries · Vegan',
    eyebrow: 'Earth Cooking',
    accent: '#8E6C25',
    items: [
      i('Daba Mixed Vegetable (v)', null, 'Garden seasonal vegetables in Pahadi-style curry.'),
      i('Daba Vegetable Handi', null, 'Prime vegetables, baby corn and tofu in chef-special handi sauce.'),
      i('Daba Maa Ki Daal', null, 'Black lentils cooked Delhi-style.'),
      i('Daba Masala Daal Fry', null, 'Yellow lentils tempered with Bombay spices.'),
      i('Daba Aloo Gobi', null, 'Potatoes and cauliflower with ginger and spices.'),
      i('Daba Chana Masala', null, 'Chickpeas with Indian spices, onion and tomato.'),
      i('Daba Broccoli Mushroom Butter Masala', null, 'Gravy with aromatic Indian spices.'),
      i('Baingan Bharta', null, 'Fire-roasted eggplant mash, slow-cooked with spices.'),
      i('Pineapple Sweet Potato Curry', null, 'Pit-roast sweet potato with rice koftas.'),
      i('Saag · Dhal', null, 'Spinach puree, yellow lentils, roasted-peanut sprinkle.'),
      i('Coconut Lime', null, 'Coconut, lemongrass, lime with garden vegetables and roasted red chillies.'),
      i('Butternut Kootu', null, 'Tender butternut, black-eyed beans and sweet raw banana in coconut gravy.'),
    ],
  },
  {
    id: 'curries-paneer',
    title: 'Pahadi Curries · Paneer',
    eyebrow: 'Cottage Cheese Classics',
    accent: '#C9A227',
    items: [
      i('Awadhi Paneer', null, "Paneer in creamy cashew sauce, chef's special."),
      i('Paneer Shahi Qurma Masala', null, 'Paneer with bell pepper and onion in a creamy masala sauce.'),
      i('Paneer Butter Masala', null, 'Paneer cooked in classic butter-masala sauce.'),
      i('Paneer Do Pyaza', null, 'Cottage cheese, shallots, tomatoes, garlic-ginger paste.'),
      i('Palak Paneer', null, 'Homemade cottage cheese in Pahadi-style spinach curry.'),
      i('Shahi Malai Kofta', null, 'Mixed-vegetable dumplings in rich masala korma.'),
      i('Aloo Rajma Masala', null, 'Red kidney beans with potatoes in a delicate tomato gravy.'),
      i('Vegetable Begum Bahar', null, 'Mashed-vegetable balls in a tomato sauce.'),
      i('Saam Savera', null, 'Spinach kofta stuffed with paneer in shahi makhani sauce.'),
    ],
  },
  {
    id: 'curries-meat',
    title: 'Pahadi Curries · Meat',
    eyebrow: "Carnivore's Corner",
    accent: '#7B2C2C',
    items: [
      i("Daba Murgh Khurchan", null, 'Chicken on the bone in Pahadi-style curry.'),
      i('Daba Chicken Kurma', null, 'Boneless chicken in creamy cashew-nut gravy.'),
      i('Daba Rampuri Tar Gosht', null, 'Tender lamb on the bone slow-cooked in yogurt gravy with caramelised onion.'),
      i('Daba Kala Gosht Lamb Bot Masala', null, 'Lamb on the bone and marrow in Pahadi-style curry.'),
      i('Daba Lahori Chicken Masala', null, 'Chicken in rich traditional karahi masala.'),
      i('Daba Kashmiri Lamb Rogan Josh', null, 'Kashmiri delicacy — you have to try.'),
      i('Daba Butter Chicken', null, 'Tandoori boneless chicken breast in makhani sauce.'),
      i('Daba Parsi Dhansak', null, 'Boneless chicken, peppers and onions in rich spiced tomato sauce.'),
      i('Daba Chickpea Chicken', null, "Chef's high-protein specialty, lush with flavour."),
      i('Daba Rara Lamb', null, 'Minced and whole lamb cooked with traditional spices.'),
      i('Daba Bohri Chicken Kurma', null, 'Boneless chicken in creamy cashew-nut gravy.'),
      i('Daba Punjabi Methi Malai Prawn', null, 'Punjabi-tradition methi prawn curry.'),
      i('Daba Coconut Lime Prawns', null),
      i('Lamb Chops', 'R350', 'Pre-marinated, cooked in a combination of gravies.'),
      i('Malabar Lamb Shank', 'R350', 'Slow-cooked shank in a fiery yet refined Malabar balance.'),
    ],
  },
  {
    id: 'tiffin',
    title: 'Tiffin Box',
    eyebrow: 'Share for Two',
    accent: '#FF6F00',
    pricing: 'Each Tiffin · R950 · Serves 2',
    items: [
      i('Option 1', null, 'Malai Kofta · Butter Chicken · Lamb Rogan Josh.'),
      i('Option 2', null, 'Paneer Makhni · Chicken Quorma · Badami Ostrich.'),
      i('Option 3', null, 'Banaras Subzi · Goan Prawn · Malai Methi Chicken.'),
    ],
  },
  {
    id: 'rice',
    title: 'From the Rice Field',
    eyebrow: 'Biryani & Pulao',
    accent: '#5C4A1F',
    pricing: 'Individual rice flavours · R65',
    items: [
      i('Parda Awadh Biryani', null, "Your choice of meat in chef's northern Indian spices."),
      i('Burnt Garlic Pulao', null, 'Basmati with coriander, curry leaf and burnt garlic.'),
      i('Mushroom Pulao', null, 'Soft rice cooked with mushroom and spices.'),
      i('Peshawari Pulao (signature)', null, 'Basmati with tutti frutti, dried fruit and nuts.'),
      i('Saffron Pulao (signature)', null, 'Basmati laced with coriander and saffron.'),
      i('Masala Stir-Fried Vegetable Egg Fried Rice', null),
    ],
  },
  {
    id: 'breads',
    title: 'Tandoori Breads',
    eyebrow: 'Hot from the Oven',
    accent: '#B25E2A',
    items: [
      i('Butter Naan', 'R40'),
      i('Garlic Naan', 'R40'),
      i('Rogni Naan', 'R40'),
      i('Cheese Chilli Naan', 'R55'),
      i('Garlic Olive Naan', 'R55'),
      i('Honey Coriander Naan', 'R55'),
      i('Jambo Masala Crispy Rumali Roti', 'R65'),
      i('Butter Chicken Khulcha', 'R65'),
      i('Lamb Rogan Khulcha', 'R75'),
      i('Aloo Khulcha', 'R65'),
      i('Feta & Olive Khulcha', 'R65'),
      i('Cheese Chilli Khulcha', 'R55'),
      i('Cheese Tomato Onion Masala Khulcha', 'R55'),
      i('Amritsari Chana Khulcha', 'R55'),
      i('Mini Stuffed Kulcha (4 pcs)', 'R75', 'Butter chicken · Rogan · Palak paneer · Gobi matter · Onion tomato — with mint chutney and raita.'),
    ],
  },
  {
    id: 'salads',
    title: 'Salads & Raita',
    eyebrow: 'Fresh & Light',
    accent: '#3F6249',
    items: [
      i('Iceberg Lettuce Steak', null, 'Grilled iceberg, seasonal fruit, roasted nuts, rosemary, avocado-lime.'),
      i('Spicy Orange Avocado Salad', null, 'Maple-balsamic vinaigrette tossed on cucumber rings.'),
      i('Asian-Style Cucumber Salad', null, 'Mumbai specialty — roasted peanuts and micro greens.'),
      i('Chole Salad', null, 'Chickpeas, cucumber, beet, sweet potato, garlic-paneer cream on rocket.'),
      i('Roasted Paneer Salad', null, 'Homemade paneer, pomegranate, smoked bell pepper, cherry tomato; sesame ginger.'),
      i('All Raitas', 'R60', 'Cucumber · Pineapple · Masala tomato · Mix salsa · Chilli-olive-oil mango-lime.'),
    ],
  },
  {
    id: 'bar',
    title: 'Bar Tongue Teasers',
    eyebrow: 'With Your Drink',
    accent: '#FF1493',
    items: [
      i('Chilli Garlic Chicken', 'R120', 'Tawa-fry, quick and flavour-packed.'),
      i('Chilli Garlic Paneer', 'R110', 'Tawa-fry, quick and flavour-packed.'),
      i('"Please Get Me Chakna" Box', 'R110', 'Masala peanut bhel, roasted chana, peri-peri kurkure, papad, nachos bhel.'),
      i('Magic Masala Cheese Fries', 'R65', 'Chipotle mayo, magic masala.'),
      i('Red Onion Pakoras', 'R65', 'Homemade rings with mango chutney mayo.'),
      i('Crispy Chilli Chana', 'R75', 'Classic crispy chana in our chilli-pepper sauce.'),
      i('Molecular Chicken Strips', 'R85', 'Panko-dusted chicken popcorn, cheddar dust, masala mayo.'),
      i('Chicken Wings', 'R85', 'Wings tossed in ginger and pan-grilled.'),
      i('Loaded Potato Wedges', 'R75', 'Wedges in chaat masala, masala cheese sauce, jalapeños.'),
      i('Aloo Tuk', 'R75', 'Patatas bravas, chukka matar, jalapeño chutney.'),
    ],
  },
  {
    id: 'desserts',
    title: 'Desserts',
    eyebrow: 'Sweet Goodbyes',
    accent: '#C2185B',
    items: [
      i('Chocolate Wine Dreams', 'R125', 'Double choc-chip ice cream with Malbec wine — one-world combo.'),
      i('Coffee Rasgulla Sundae', 'R110', 'Delicate rasgulla in thick coffee-cream syrup.'),
      i('Hazelnut Chocolate Samoosa', 'R110', 'Salted-caramel ice cream, toasted nut brittle.'),
      i('Trio Malai Ice Cream', 'R110', 'Pistachio · Rose · Malai.'),
      i('Salted Chips Dipped in Chocolate', 'R110', 'Served frozen — this is global.'),
      i('Chocolate Gulab Jamun in Saffron Syrup', 'R110', 'Delicate jamun with hazelnut chocolate drizzle.'),
      i('Masala Chai Gelato with Gulab Jamun', 'R110', 'Going global with a fusion concept.'),
      i('Pistachio-Rolled Gulab Jamun', 'R110', 'Homemade jamun swirled in pistachio puree.'),
    ],
  },
  {
    id: 'drinks',
    title: 'Lassi · Falooda · Frappés',
    eyebrow: 'Sips & Coolers',
    accent: '#FFB300',
    items: [
      i('Classic Lassi & Chaas', null, 'Plain · Masala · Mango · Jeera · Carrot Halwa · Strawberry · Kiwi · Blueberry · Mango Chaas.'),
      i('Mastani Faloodas', null, 'Mumbai Mastani Malai · Rose · Pistachio · Mango.'),
      i('Biryani Milkshake', null, "O'Geet specialty — pure chaos."),
      i('Popcorn Milkshake', null, "O'Geet specialty — pure chaos."),
      i('Biryani Mango Pickle Shake', null, "O'Geet — pure chaos."),
      i('Frappés', null, 'Cookies & cream · Mocha · Matcha · Caramel · Coffee · Cappuccino brulée.'),
    ],
  },
];
